'use strict';
var food = {
    Drink: {
        Wine: {},
        Schnaps: {}
    },
    Fruit: {
        Red: {
            Cherry: {},
            Strawberry: {}
        },
        Yellow: {
            Banana: {},
            Pineapple: {}
        }
    }
};
var tree = document.querySelector('#tree');
function createTree(element, data) {
    for(var key in data){
        var li = document.createElement('li');
        li.textContent = key;
        element.appendChild(li);
        if (Object.keys(data[key]).length > 0) {
            var ul = document.createElement('ul');
            li.appendChild(ul);
            createTree(ul, data[key]);
        }
    }
}
createTree(tree, food);

//# sourceMappingURL=js_tree-from-object-DOM.0e775aef.js.map
